import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../redux/actions';
import * as commonActions from '../../common/redux/actions';
import * as pluginActions from '../../plugin/redux/actions';
import MailTemplateForm from './MailTemplateForm';
import { EditorState, ContentState } from 'draft-js';
import htmlToDraft from 'html-to-draftjs';
import { getTemplateFormCollectionFieldOptions } from './MailTemplateFormUtil';
import { drapcodeIcon } from '../../../common/custom/icon-library';
import ParentDocCard from '../../common/ParentDocCard';
import DocsLink from '../../../common/custom/DocsLink';
import { TemplateHeaderNav } from '../TemplateHeaderNav';
import { EMAIL_TEMPLATE } from 'drapcode-constant';
import { isProjectReadOnly } from '../../../common/utils/api_utils';

export class MailTemplateEdit extends Component {
  static propTypes = {
    template: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    editorState: EditorState.createEmpty(),
    name: '',
    subject: '',
    collectionId: '',
    selectedCollectionFields: [],
    attachmentField: '',
  };

  componentDidMount = () => {
    const { match, actions, pluginActions } = this.props;
    const { projectId, templateId, version } = match.params;
    const args = { projectId, templateId, version };
    actions.loadProjectDetail({ projectId, version });
    actions.loadCollections({ projectId, version });
    actions.fetchTemplate(args);
    pluginActions.loadAllInstalledPlugin({ projectId, version });
  };

  shouldComponentUpdate = (nextProps, nextState) => {
    const {
      template: { template, collections },
    } = nextProps;
    console.log('template', template);
    const { name: stateName } = this.state;
    if (!stateName) {
      const { content, name, subject, collectionId, attachmentField } = template ? template : {};
      const selectedCollection = collections.find((e) => e.collectionName === collectionId);
      const selectedCollectionFields = selectedCollection
        ? getTemplateFormCollectionFieldOptions(selectedCollection, collections)
        : [];
      if (content) {
        const blocksFromHtml = htmlToDraft(content);
        const { contentBlocks, entityMap } = blocksFromHtml;
        const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
        const editorState = EditorState.createWithContent(contentState);
        this.setState({
          name: name,
          subject: subject,
          collectionId: collectionId,
          editorState: editorState,
          selectedCollectionFields: selectedCollectionFields,
          attachmentField: attachmentField,
        });
      }
    }

    return true;
  };

  handleSubmit = (values) => {
    const { projectId, templateId, version } = this.props.match.params;
    let args = {
      projectId: projectId,
      templateId: templateId,
      version,
      values: values,
    };
    this.props.actions.updateTemplate(args);
  };
  toggle = (activeTab) => {
    const { projectId, version } = this.props.match.params;
    this.props.history.push({
      pathname: `/template/${version}/v/${projectId}`,
      state: { activeTab: activeTab },
    });
  };
  render() {
    const { editorState, subject, name, collectionId, selectedCollectionFields, attachmentField } =
      this.state;
    const {
      template: { collections, updateTemplatePending, template },
      projectDetail,
      match,
      plugin: { installedPlugins },
    } = this.props;
    console.log('projectDetail in mail template edit', projectDetail);
    const { projectId, templateId } = match.params;
    const isReadOnly = isProjectReadOnly(projectId);
    return (
      <div className="main">
        <div className="section">
          <div className="container">
            <TemplateHeaderNav
              activeTab={EMAIL_TEMPLATE}
              title={'Email Templates'}
              toggle={this.toggle}
              installedPlugins={installedPlugins}
            />
            <div className="row mx-auto">
              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
                <div className="card">
                  <div
                    className="card-header card-header-icon"
                    data-background-color="drapcode-dark-blue"
                  >
                    <i className={`wb ${drapcodeIcon(EMAIL_TEMPLATE)}`}></i>
                  </div>
                  <div className="card-content">
                    {name ? (
                      <MailTemplateForm
                        handleSubmit={this.handleSubmit}
                        editorState={editorState}
                        name={name}
                        collectionId={collectionId}
                        subject={subject}
                        collections={collections}
                        selectedCollectionFields={selectedCollectionFields}
                        updateTemplatePending={updateTemplatePending}
                        templateId={templateId}
                        projectDetail={projectDetail}
                        attachmentField={attachmentField}
                        projectId={this.props.match.params.projectId}
                        version={this.props.match.params.version}
                        actions={this.props.actions}
                        isReadOnly={isReadOnly}
                      />
                    ) : null}
                  </div>
                </div>
              </div>
              <ParentDocCard>
                <h5>
                  <b>Email Template</b>
                </h5>
                <p>
                  You can create custom email templates and send them to different users. We have
                  created a step-by-step documentation that covers email template creation, event
                  configuration and execution.
                </p>
                <br />
                <DocsLink link="https://academy.drapcode.com/docs/app-event/event-dynamic-email-action/" />
              </ParentDocCard>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    template: state.template,
    projectDetail: state.common.projectDetail,
    plugin: state.plugin,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, ...commonActions }, dispatch),
    pluginActions: bindActionCreators({ ...pluginActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MailTemplateEdit);
